import { get } from "../../utils/objectHelpers";

<if(input)>
    $ {
        const storeLogoLink = get(input, 'storeLogo.action.URL', '');
        const storeLogoTracking = JSON.stringify(get(input, 'storeLogo.action.trackingList.0', ''));
        const storeLogoURL = get(input, 'storeLogo.URL', '');
        const storeLogoTitle = get(input, 'storeLogo.title', '');
        const displayName = get(input, 'displayName.textSpans', []);
        const displayNameLink = get(input, 'displayName.action.URL', '');
        const displayNameTracking = JSON.stringify(get(input, 'displayName.action.trackingList.0', ''));
        const saveSellerAction = get(input, "saveSellerAction", {});
    }
    <div class="str-mini-header-wrap" key="str-mini-header-wrap" style="display: none;">
        <header class="str-mini-header app-layout app-layout--gutters" data-testid="header-mini">
            <div class="str-mini-header__info">
                <a class="str-mini-header__logo" href=storeLogoLink data-track=storeLogoTracking>
                    <img class="str-mini-header__logo--img" src=storeLogoURL alt=storeLogoTitle data-testid="hdr-logo"/>
                </a>
                <div class="str-mini-header__details">
                    <div class="str-mini-header__intro">
                        <h1 class="str-mini-header__title large-section-title">
                            <a href=displayNameLink data-track=displayNameTracking>
                                <str-text-span textSpans=displayName />
                            </a>
                        </h1>
                        <div class="str-mini-header__follow-container">
                            <div class="str-mini-header__follow">
                                <follow-ebay
                                    fakeLink=true blackButton=true noText=true
                                    config=saveSellerAction
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    </div>
</if>